import React, { ReactElement, useContext } from 'react';
import { faClock, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

import OrgBannerStyles from './styles';

import OrganizationContext from '../../../contexts/OrganizationContext';
import GlobalContext from '../../../contexts/GlobalContext';
import { useLoyalty } from '../../../hooks/Loyalty';

import ModalButton from './ModalButton';
import WorkHoursContent from './WorkHoursContent';
import DeliveryContent from './DeliveryContent';
import LoyaltyContent from './LoyaltyContent';

import TrophyIcon from '../../../images/icons/trophy.svg';

const OrgBanner: React.FC = (): ReactElement => {
  const { organizationInfo } = useContext(OrganizationContext);
  const { isLoggedIn } = useContext(GlobalContext);
  const { loyaltyProgram, memberPoints } = useLoyalty();

  const shouldRenderLoyaltyData = !!loyaltyProgram && loyaltyProgram.active;
  const isOpen = !!organizationInfo && organizationInfo.isInWorkHour;

  let statusLabel = 'Fechado';

  if (isOpen) {
    statusLabel =
      !!organizationInfo && organizationInfo.alwaysOpen
        ? 'Peça agora'
        : 'Aberto';
  }

  const hasLoyaltyProgram = !!loyaltyProgram && !!memberPoints;
  const hasCartPoints = `${memberPoints && memberPoints.cartPoints} pontos`;

  const modals = (
    <>
      {organizationInfo && (
        <OrgBannerStyles.ButtonsAndStatusContainer
          shouldAddTopMargin={!shouldRenderLoyaltyData}
        >
          <OrgBannerStyles.ModalButtonsWrapper>
            {!organizationInfo.alwaysOpen && (
              <ModalButton
                icon={faClock}
                label="Horários"
                modalContent={<WorkHoursContent />}
              />
            )}

            <ModalButton
              icon={faMapMarkerAlt}
              label="Ver mais"
              modalContent={<DeliveryContent />}
            />
          </OrgBannerStyles.ModalButtonsWrapper>

          <OrgBannerStyles.ModalButtonsWrapper>
            <OrgBannerStyles.StatusLabel isOpen={isOpen}>
              {statusLabel}
            </OrgBannerStyles.StatusLabel>

            <ModalButton
              svgIcon={TrophyIcon}
              label={isLoggedIn ? hasCartPoints : 'Ver Mais'}
              modalContent={<LoyaltyContent />}
            />
          </OrgBannerStyles.ModalButtonsWrapper>

          {shouldRenderLoyaltyData && (
            <OrgBannerStyles.LoyaltyContainer>
              <p>
                <OrgBannerStyles.IconSvg
                  src={TrophyIcon}
                  alt="Icone Programa de Fidelidade"
                />{' '}
                Programa de fidelidade
              </p>

              <p>Junte pontos e troque por produtos</p>

              <div>
                <ModalButton
                  label="Veja lista"
                  modalContent={<LoyaltyContent />}
                />

                {hasLoyaltyProgram && (
                  <span>
                    Você tem <strong>{hasCartPoints}</strong>
                  </span>
                )}
              </div>
            </OrgBannerStyles.LoyaltyContainer>
          )}
        </OrgBannerStyles.ButtonsAndStatusContainer>
      )}
    </>
  );

  return (
    <OrgBannerStyles.Container>
      {organizationInfo && (
        <>
          <OrgBannerStyles.Background
            color={organizationInfo.headerColor}
            headerUrl={organizationInfo.headerUrl}
          />

          <OrgBannerStyles.Content>
            <OrgBannerStyles.Logo src={organizationInfo.logoUrl} />

            {modals}

            <OrgBannerStyles.ContentColumn>
              <OrgBannerStyles.Name>
                {organizationInfo.name}
              </OrgBannerStyles.Name>

              <OrgBannerStyles.Description>
                {organizationInfo.description}
              </OrgBannerStyles.Description>

              {modals}
            </OrgBannerStyles.ContentColumn>
          </OrgBannerStyles.Content>
        </>
      )}
    </OrgBannerStyles.Container>
  );
};

export default OrgBanner;
